<template>
    <header class="page-banner-area position-relative" id="home">
        <div class="section-overlay d-flex">
            <div class="container">
                <div class="header-caption">
                    <h1 class="header-caption-heading text-capitalize">{{ pageTitle }}</h1>
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li
                                v-for="(data, index) of breadCrumb"
                                :key="index"                                
                                class="breadcrumb-item text-capitalize"
                                
                                >
                                <router-link :to="data.path">
                                    <i class="fas fa-angle-right" v-if="(index > 0)"></i>{{ data.title }}
                                </router-link>
                            </li>
                            <!-- <li class="breadcrumb-item active text-capitalize" aria-current="page"><i class="fas fa-angle-right"></i>About Us</li> -->
                            
                        </ol>
                    </nav>
                </div>
            </div>
        </div>

        <!-- Effect Start-->
        <img class="bubble slow" src="../../public/img/all-effect-img/Top_bubble.svg" id="pink-side-bubble-1" alt="b">
        <img class="bubble" src="../../public/img/all-effect-img/Bottom_Bubble.svg" id="pink-side-bubble-2" alt="b">
        <img class="bubble slow" src="../../public/img/all-effect-img/Bog-Blob.svg" id="blue-side-bubble-1" alt="b">
        <!-- Effect End-->

        <!-- Wave Effect Start-->
        <div class="footer-wave"></div>
        <!-- Wave Effect End-->

    </header>
</template>

<script>
export default {
    props:{
        title: String,
        bredcrumb: Array
    },
    data(){
        return {
            pageTitle: 'Home',
            breadCrumb: []
        }
    },
    created: function(){
        this.pageTitle = this.$props.title
        this.breadCrumb = this.$props.bredcrumb
    },
    watch: {
        'title'(){
            this.pageTitle = this.$props.title
        },
    }
}
</script>
